import React from "react";

export interface HashpassMarkerProps {
  isStraight: boolean;
  numberOfHashes: number;
}

export const HashpassMarker = ({ isStraight, numberOfHashes }: HashpassMarkerProps) => {
  const lineType = isStraight ? "STRAIGHT" : "PATH";

  const hashes = Array(numberOfHashes)
    .fill(0)
    .map((_d, i): number => {
      const side = i % 2 === 1 ? -1 : 1;
      return Math.round(i / 2) * side * 3;
    });

  return (
    <marker
      id={`hashpass_${lineType}_${numberOfHashes}`}
      viewBox="-6 0 50 50"
      refX={isStraight ? "3" : "0"}
      refY="4"
      markerWidth="50"
      markerHeight="50"
      orient="auto-start-reverse"
    >
      {hashes.map((hash, key) => (
        <rect x={hash} y="0" width={1} height={8} fill="#000" key={key} />
      ))}
    </marker>
  );
};
